import { getAnonymousUserId, getDatadogConfig, getVyEnv } from "./utils";

export const initDatadogRum = () => {
  const vyEnv = getVyEnv();

  // Skip in local development
  if (["dev", "local"].includes(vyEnv)) {
    console.log(`Skipping Datadog Analytics initialization in env: ${vyEnv}`);
    return;
  }
  const datadogConfig = getDatadogConfig();
  if (!datadogConfig) {
    console.warn("Datadog Analytics config not found, skipping initialization");
    return;
  }

  // Only import RUM for analytics
  import("@datadog/browser-rum")
    .then(({ datadogRum }) => {
      datadogRum.init({
        site: "datadoghq.eu",
        applicationId: datadogConfig.applicationId,
        clientToken: datadogConfig.clientToken,
        service: datadogConfig.service,
        env: vyEnv,
        sessionSampleRate: 100,
        version: import.meta.env.VERSION,
        startSessionReplayRecordingManually: true,

        // NO SESSION REPLAY
        sessionReplaySampleRate: 0, // Explicitly disable

        // Product Analytics tracking
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask",

        // Privacy settings
        enablePrivacyForActionName: true,
        actionNameAttribute: "data-dd-action-name",
        trackAnonymousUser: false,
        storeContextsAcrossPages: false,

        // Performance optimizations
        allowedTracingUrls: [], // Don't trace external requests unless needed
      });

      datadogRum.setUser({
        id: getAnonymousUserId(),
      });
      console.log("Datadog RUM initialized.");
    })
    .catch((error) => {
      console.warn("Failed to initialize Datadog Analytics:", error);
    });
};
